import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  OnChanges,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { UntypedFormControl } from "@angular/forms";
import { ISkillNode } from "../../../models/skillNode";
import ISkillsKeyedByType from "@skills-app/models/skillsKeyedByType";

@Component({
  standalone: false,
  selector: "app-skill-filter",
  templateUrl: "./skill-filter.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./skill-filter.component.css"],
})
export class SkillFilterComponent implements OnChanges, OnDestroy {
  @Input() skills: ISkillNode[] = [];
  @Input() hideToggleSwitches: boolean = false;
  @Output() filterSkills = new EventEmitter<ISkillsKeyedByType>();

  public filterFormControl = new UntypedFormControl("");
  private inputValue: Subscription;

  constructor() {
    this.inputValue = this.filterFormControl.valueChanges
      .pipe(debounceTime(500))
      .subscribe((skillName) => this.filter(skillName));
  }

  ngOnChanges(): void {
    const currentInputValue = (this.filterFormControl.value as string) ?? "";
    const trimmed = currentInputValue.trim();

    if (trimmed.length > 0) {
      this.filter(trimmed);
    } else {
      this.filterSkills.emit(this.keyBySkillType(this.skills ?? []));
    }
  }

  ngOnDestroy(): void {
    this.inputValue?.unsubscribe();
  }

  filter(inputValue: string): void {
    const needle = (inputValue ?? "").toLowerCase();
    const source = this.skills ?? [];

    this.filterSkills.emit(
      this.keyBySkillType(
        source.filter((skill) =>
          (skill?.Name ?? "").toLowerCase().includes(needle),
        ),
      ),
    );
  }

  keyBySkillType(skills: ISkillNode[]): ISkillsKeyedByType {
    const skillsKeyedByType: any = {
      skillTypeNames: [],
    };

    (skills ?? []).forEach((element) => {
      const skillTypeName = element?.SkillType?.Name ?? "Uncategorized";

      if (skillsKeyedByType.skillTypeNames.indexOf(skillTypeName) === -1) {
        skillsKeyedByType.skillTypeNames.push(skillTypeName);
      }
      if (!(skillTypeName in skillsKeyedByType)) {
        skillsKeyedByType[skillTypeName] = [];
      }
      skillsKeyedByType[skillTypeName].push(element);
    });

    skillsKeyedByType.skillTypeNames = skillsKeyedByType.skillTypeNames.sort();
    return skillsKeyedByType as ISkillsKeyedByType;
  }
}
